import { useTranslation } from 'react-i18next'
import type { UserType } from '@dhl/mdp-api'
import { Body2, Box, Button, Card, Grid } from '@dhl-ui/components'
import { UUID } from '~/common/model'
import type { User } from '~/modules/users/model'
import { EditUserOrganisationAccounts, EditUserOrganisation } from '~/modules/users/components'

type Props = {
  user: User
  onOrganisationChanged: (userId: UUID, newUserType: UserType, newOrganisationId: string) => void
  onCancel: () => void
}

export const EditUserOrganisationCard = ({ user, onOrganisationChanged, onCancel }: Props) => {
  const { t } = useTranslation()

  return (
    <Card>
      <Card.Header title={t('admin.usersPage.organisationDetailsView.titleText')} />
      <Card.Content>
        <Grid container spacing={1} direction="column">
          <Grid>
            <Body2 variant="tertiary">{t('admin.usersPage.organisationDetailsView.OrganisationCompany')}</Body2>
          </Grid>
          <EditUserOrganisation user={user} onOrganisationChanged={onOrganisationChanged} />
        </Grid>
        <EditUserOrganisationAccounts user={user} />
        <Grid>
          <Box marginTop={2} display="flex" justifyContent="flex-end">
            <Box marginRight={2}>
              <Button data-testid="click-cancel" size="medium" variant="outlined" color="primary" onClick={onCancel}>
                {t('admin.form.done')}
              </Button>
            </Box>
          </Box>
        </Grid>
      </Card.Content>
    </Card>
  )
}
